import CategoryIcon from "@material-ui/icons/Category";
import SecurityIcon from "@material-ui/icons/Security";
import SearchIcon from "@material-ui/icons/Search";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import BuildIcon from "@material-ui/icons/Build";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import VisibilityIcon from "@material-ui/icons/Visibility";
import BugReportIcon from "@material-ui/icons/BugReport";
import PeopleIcon from "@material-ui/icons/People";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import TuneIcon from "@material-ui/icons/Tune";
import RateReviewIcon from "@material-ui/icons/RateReview";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import GetAppIcon from "@material-ui/icons/GetApp";
import BrushIcon from "@material-ui/icons/Brush";
import AddBoxIcon from "@material-ui/icons/AddBox";
import EditIcon from "@material-ui/icons/Edit";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ArchiveIcon from "@material-ui/icons/Archive";
import BusinessIcon from "@material-ui/icons/Business";
import ReplayIcon from "@material-ui/icons/Replay";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

const RULE_ICONS = {
  SecurityIcon,
  CategoryIcon,
  SearchIcon,
  AccountBalanceIcon,
  BuildIcon,
  ViewModuleIcon,
  PictureAsPdfIcon,
  VisibilityIcon,
  BugReportIcon,
  PeopleIcon,
  PlayArrowIcon,
  TuneIcon,
  RateReviewIcon,
  SupervisedUserCircleIcon,
  GetAppIcon,
  BrushIcon,
  AddBoxIcon,
  EditIcon,
  AssignmentIcon,
  ArchiveIcon,
  BusinessIcon,
  ReplayIcon,
  DeleteOutlineIcon,
};

/**
 * Mesmo mapa da tela de configuração do usuário (ServiceTree).
 * `rule.rule_icon` vem do catálogo /users/services (chave deste mapa, ex.: "SecurityIcon", "DeleteOutlineIcon").
 */
export function getRuleIconComponent(rule) {
  const name = rule?.rule_icon ?? rule?.icon_name;
  if (!name) return null;
  return RULE_ICONS[name] || null;
}

/**
 * Índices a partir da resposta de GET /users/services (igual ao UserManagement + ServiceTree).
 */
export function buildServicesIconCatalog(services) {
  const byServiceRuleId = new Map();
  const byProductKey = new Map();
  (services || []).forEach((s) => {
    (s.rules || []).forEach((r) => {
      if (r.rule_id != null) {
        byServiceRuleId.set(String(r.rule_id), r.rule_icon);
      }
    });
    (s.products || []).forEach((p) => {
      (p.rules || []).forEach((r) => {
        if (p.product_code != null && r.rule_id != null) {
          byProductKey.set(`${p.product_code}-${r.rule_id}`, r.rule_icon);
        }
      });
    });
  });
  return { byServiceRuleId, byProductKey };
}

/**
 * Preenche rule_icon a partir do catálogo quando o preview da API não trouxe o campo.
 */
export function resolveRuleIconName(rule, variant, productCode, catalog) {
  const direct = rule?.rule_icon ?? rule?.icon_name;
  if (direct) return direct;
  if (!catalog) return null;
  if (variant === "service" && rule?.service_rule_id != null) {
    return catalog.byServiceRuleId.get(String(rule.service_rule_id)) || null;
  }
  if (variant === "product") {
    const pc = productCode ?? rule?.product_code;
    if (pc != null && rule?.rule_id != null) {
      return catalog.byProductKey.get(`${pc}-${rule.rule_id}`) || null;
    }
  }
  return null;
}

export { SecurityIcon, CategoryIcon };
